// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'es6-promise/dist/es6-promise.auto'
import Vue from 'vue'
import App from './App'
import router from './router'
import VueSimpleSVG from 'vue-simple-svg'
import SocialSharing from 'vue-social-sharing'
import store from './store'
// import { Bus } from '@/components/Bus'

// Styles
import '@/styles/screen.scss'


Vue.use(SocialSharing)
Vue.use(VueSimpleSVG)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  store
})



// WEBPACK FOOTER //
// ./src/main.js